import { MutationTree } from 'vuex';
import IServicesState from './types/IServicesState';
import IServiceMeta from './types/IServiceMeta';
import IServiceHeader from './types/IServieHeader';
import IService from './types/IService';

const mutations: MutationTree<IServicesState> = {
  setMeta(state: IServicesState, meta: IServiceMeta) {
    state.meta = meta;
  },

  setHeader(state: IServicesState, header: IServiceHeader) {
    state.header = header;
  },

  setServices(state: IServicesState, services: IService[]) {
    state.services = services;
  },
};

export default mutations;
